'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var useOrderTracking = require('@narvar/nth-hook-order-tracking');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var ExpandableImage = require('@narvar/nth-block-expandable-image');
var nthBitHeader = require('@narvar/nth-bit-header');
var Divider = require('@narvar/nth-bit-divider');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var nthKitDynamicLayoutNext = require('@narvar/nth-kit-dynamic-layout-next');
var clsx = require('clsx');
var Vpod_module = require('./Vpod.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var useOrderTracking__default = /*#__PURE__*/_interopDefaultLegacy(useOrderTracking);
var ExpandableImage__default = /*#__PURE__*/_interopDefaultLegacy(ExpandableImage);
var Divider__default = /*#__PURE__*/_interopDefaultLegacy(Divider);

const {
  FeatureLayout
} = nthKitDynamicLayoutNext.LayoutTree;
const breakpoint = 768;
const VPOD = ({
  featureName,
  layout
}) => {
  const landscape = layout === FeatureLayout.LANDSCAPE;
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const {
    packEddPanelProofOfDelivery,
    packEddPanelProofOfDeliveryContractImage,
    packEddPanelProofOfDeliveryExpandImage
  } = nthHookTranslations.useTranslations();
  const container = React.useRef(null);
  const [isValidImage, setIsValidImage] = React.useState(false);
  const {
    getCurrentShipment
  } = useOrderTracking__default["default"]();
  const currentShipment = getCurrentShipment();
  const handleExpand = () => {
    logEvent({
      clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.VPOD_EXPAND,
      clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.VPOD_EXPAND,
      clickType: nthHookContextAnalytics.NarvarClickTypes.INTERACTION,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_VPOD,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_VPOD,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_VPOD,
      trackLayout: layout
    });
    // Scroll to the top of the proof of delivery component
    if (window.innerWidth < breakpoint && container.current) {
      window.scrollTo({
        behavior: 'smooth',
        top: container.current.getBoundingClientRect().top + window.scrollY - document.getElementsByTagName('header')[0].clientHeight
      });
    }
  };
  const handleContract = () => {
    logEvent({
      clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.VPOD_CONTRACT,
      clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.VPOD_CONTRACT,
      clickType: nthHookContextAnalytics.NarvarClickTypes.INTERACTION,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_VPOD,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_VPOD,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_VPOD,
      trackLayout: layout
    });
  };
  const url = currentShipment?.verificationContent?.url;
  React.useEffect(() => {
    if (!url) return;
    logEvent({
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_VPOD,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_VPOD,
      eventType: nthHookContextAnalytics.NarvarEventTypes.COMPONENT_RENDER,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_VPOD,
      trackLayout: layout
    });
  }, [url, layout, featureName, logEvent]);
  if (!url) return null;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: clsx.clsx({
      [Vpod_module["default"].containerOuterHidden]: !isValidImage
    }),
    "aria-hidden": !isValidImage
  }, !landscape && /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], {
    featureName: featureName
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: Vpod_module["default"].container,
    ref: container
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, {
    as: "h3",
    featureName: featureName,
    containerCustomStyle: {
      marginBottom: '0.5rem'
    }
  }, packEddPanelProofOfDelivery), /*#__PURE__*/React__default["default"].createElement(ExpandableImage__default["default"], {
    featureName: featureName,
    src: url,
    alt: packEddPanelProofOfDelivery ?? '',
    expandAriaLabel: packEddPanelProofOfDeliveryExpandImage ?? '',
    contractAriaLabel: packEddPanelProofOfDeliveryContractImage ?? '',
    onExpand: handleExpand,
    onContract: handleContract,
    onValidImageDetermined: valid => {
      setIsValidImage(valid);
    }
  })), landscape && /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], {
    featureName: featureName
  }));
};
var Vpod = nthHookTranslations.withTranslationsProvider(VPOD, {
  translationKeys: ['packEddPanelProofOfDelivery', 'packEddPanelProofOfDeliveryContractImage', 'packEddPanelProofOfDeliveryExpandImage']
});

exports["default"] = Vpod;
